import {
    VIEW_JOBLIST_REQUEST,VIEW_JOBLIST_SUCCESS,VIEW_JOBLIST_FAIL
} from "../constants/AuthConstant";
  
  const initialState = {
    loading: false,
    action: "Job Action",
    result: [],
    msg: "",
    error: "",
  };
  
  const JobDetailsReducer = (state = initialState, action) => {
    switch (action.type) {
      case VIEW_JOBLIST_REQUEST:
        return {
          ...state,
          loading: action.payload,
        };
      case VIEW_JOBLIST_SUCCESS:
        return {
          ...state,
          result: action.result.data,
          loading: action.payload,
          msg: action.msg,
        };
      case VIEW_JOBLIST_FAIL:
        return {
          ...state,
          error: action.error,
          loading: action.payload,
          msg: action.msg,
        };
  
      default:
        return state;
    }
  };
  
  export default JobDetailsReducer;
  